import i18next from 'i18next';
import React from 'react';

import { InpulseLabel } from '@commons/DeepsightComponents';
import { labelContainerStyle } from '@commons/constants/labelStyle';

import { ENTITY_UNITS } from '@commons/constants/units';
import { isEmpty } from 'lodash';
import { Text } from '../components/styledComponents';

const renderLabel = (item) => (
  <div className="supplier-label-render" style={labelContainerStyle}>
    <InpulseLabel color={item > 0 ? 'green' : 'red'} text={String(item)} />
  </div>
);

export const getColumns = () => [
  {
    id: 'ingredientName',
    name: i18next.t('GENERAL.NAME'),
    displayName: i18next.t('GENERAL.NAME'),
    propertyKey: 'name',
    baseName: 'name',
    large: true,
    render: (item) => <Text highlighted>{item}</Text>,
  },
  {
    id: 'category',
    baseName: 'category',
    propertyKey: 'categoryId',
    displayName: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_CATEGORY'),
    name: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_CATEGORY'),
    filterType: 'string',
    filterStringAllowNone: true,
    render: (_, { category }) => <Text>{category || '-'}</Text>,
  },
  {
    id: 'unit',
    baseName: 'unit',
    propertyKey: 'unit',
    displayName: i18next.t('GENERAL.TOGGLE_BUTTON_UNIT', { count: 1 }),
    name: i18next.t('GENERAL.TOGGLE_BUTTON_UNIT', { count: 1 }),
    excludeFromSearch: true,
    filterType: 'string',
    render: (item) => <Text>{item}</Text>,
  },
  {
    id: 'cost',
    baseName: 'cost',
    propertyKey: 'cost',
    filterType: 'numeric',
    displayName: i18next.t('ADMIN.INGREDIENTS.LABEL_COST'),
    name: i18next.t('ADMIN.INGREDIENTS.LABEL_COST'),
    excludeFromSearch: true,
    render: (_, ingredient) => <Text>{ingredient.costStr}</Text>,
  },
  {
    id: 'supplierProductMappingCount',
    baseName: 'supplierProductMappingCount',
    propertyKey: 'supplierProductMappingCount',
    displayName: i18next.t('FEATURE.ADMIN.SUPPLIERS_PRODUCTS'),
    name: i18next.t('FEATURE.ADMIN.SUPPLIERS_PRODUCTS'),
    excludeFromSearch: true,
    filterType: 'numeric',
    disableSort: true,
    render: (item) => renderLabel(item),
  },
  {
    id: 'parentCounts',
    baseName: 'parentCounts',
    propertyKey: 'parentCounts',
    displayName: i18next.t('ADMIN.INGREDIENTS.USING'),
    name: i18next.t('ADMIN.INGREDIENTS.USING'),
    excludeFromSearch: true,
    filterType: 'numeric',
    disableSort: true,
    render: (item) => renderLabel(item),
  },
];

export const getColumnsFilterList = (columns, categories) => {
  const columnsList = columns.reduce((result, column) => {
    if (!column.filterType) {
      return result;
    }

    const item = { ...column };

    if (column.filterType === 'string' && column.propertyKey === 'categoryId') {
      const choices = categories.reduce((acc, category, index) => {
        acc.push({
          id: index,
          name: category.name,
          categoryId: category.id,
        });

        return acc;
      }, []);

      if (isEmpty(choices)) {
        return result;
      }

      item.list = choices;
    }

    if (column.filterType === 'string' && column.propertyKey === 'unit') {
      const choices = [
        {
          id: 0,
          name: i18next.t('GENERAL.UNIT'),
          unit: ENTITY_UNITS.UNIT,
        },
        {
          id: 1,
          name: ENTITY_UNITS.GRAM,
          unit: ENTITY_UNITS.GRAM,
        },
        {
          id: 2,
          name: ENTITY_UNITS.MILLILITER,
          unit: ENTITY_UNITS.MILLILITER,
        },
      ];

      item.list = choices;
    }

    result.push(item);

    return result;
  }, []);

  return columnsList;
};

export default { getColumns, getColumnsFilterList };
